/**
 * Rocksoft Places API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeviceType = {
    Apple: 'Apple',
} as const;
export type DeviceType = typeof DeviceType[keyof typeof DeviceType];

